.SDSSlider__container {
  position: relative;
  padding: 8px 0 24px;
  width: 100%;
}

.SDSSlider {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  height: 20px;
  touch-action: none;

  &__control {
    position: relative;
    display: flex;
    align-items: center;
    width: 100%;
    height: 100%;
    touch-action: none;
  }

  &__track {
    position: relative;
    flex-grow: 1;
    height: 4px;
    background: var(--input-default);
    border-radius: 2px;
  }

  &__indicator {
    position: absolute;
    height: 100%;
    background: var(--brand-primary);
    border-radius: 2px;
  }

  &__thumb {
    position: absolute;
    width: 20px;
    height: 20px;
    background: var(--brand-primary);
    border: 2px solid var(--background-fill);
    border-radius: 50%;
    cursor: grab;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);

    &:focus-visible {
      outline: 2px solid var(--brand-primary);
      outline-offset: 2px;
    }

    &:active {
      cursor: grabbing;
    }
  }

  &[data-disabled] {
    opacity: 0.6;
    cursor: not-allowed;

    .SDSSlider__thumb {
      cursor: not-allowed;
    }
  }
}

.SDSSlider__marks {
  position: relative;
  width: 100%;
  margin-top: 8px;
}

.SDSSlider__mark {
  position: absolute;
  transform: translateX(-50%);

  &-label {
    font-size: 12px;
    color: var(--text-secondary);
    white-space: nowrap;
  }
}
